import { Box, IconButton, LinearProgress, Tab, Tabs } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { useSelector } from "react-redux";
import { WrapMain } from 'src/shared/modules/wrap_main';
import { getDailySummaryReportAlone } from 'src/shared/util/requestDataServer';
import { selectGtoState } from 'src/stateManagement/redux/store';
import ButtonCircle from "../../../../../shared/components/button_circle";
import { useNavigate } from 'react-router-dom';
import Grid from "@mui/material/Grid2";
import { CustomTabPanel } from '../close_daily';
import DownloadIcon from '@mui/icons-material/Download';
import './tableStyles.scss'
import { convertArrayOfObjectsToCSV } from 'src/shared/util/functions';
import * as XLSX from 'xlsx';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import DashboardIcon from "@mui/icons-material/Dashboard";
import { ChartForSummary } from './charts';

type TabletsType = {
  [key: string]: {
    Title: string;
    header: string[];
    data: {
      name: string;
      activitiesField: string;
      potencialField: string;
    }[];
  };
};

interface dataToDowload {
  section: string;
  name: string;
  activitiesField: any;
  potencialField: any;
}


const internalTabs = [
  { "name": "Resumen", "value": "summary", icon: <TextSnippetIcon /> },
  // { "name": "shortChart", "value": "shortChart", icon: <TableRowsIcon /> },
  { "name": "detaileChart", "value": "charts", icon: <DashboardIcon /> },
]

const tablets: TabletsType = {
  "operationState": {
    "Title": "Estados de Operacion",
    "header": ['Tipo Actividad', 'Actividades', 'Potencial (BNPD)'],
    "data": [
      { "name": "Operando Con Aporte", "activitiesField": "operandoConAporte", "potencialField": "potoperandoConAporte" },
      { "name": "Restaurados", "activitiesField": "restaurados", "potencialField": "potrestaurados" },
      { "name": "Observacion", "activitiesField": "enObservacion", "potencialField": "potenObservacion" },
      { "name": "Sin Acceso", "activitiesField": "sinAcceso", "potencialField": "potsinAcceso" },
      { "name": "IT", "activitiesField": "it", "potencialField": "potit" },
      { "name": "Operando Sin Aporte", "activitiesField": "operandoSinAporte", "potencialField": "potoperandoSinAporte" },
    ]
  },
  "pozosTrabajados": {
    "Title": "Pozos Trabajados",
    "header": ['Tipo Actividad', 'Actividades', 'Potencial (BNPD)'],
    "data": [
      { "name": "Pozos Restaurados", "activitiesField": "pozosReespaceados", "potencialField": "potpozosReespaceados" },
      { "name": "Pozos Reespaceados", "activitiesField": "restaurados", "potencialField": "potrestaurados" },
    ]
  },
  "estadosFrenos": {
    "Title": "Estado Stuffing Box",
    "header": ['Tipo Actividad', 'Actividades', 'Potencial (BNPD)'],
    "data": [
      { "name": "Pozos con Stuffing Bueno", "activitiesField": "pozosStufingBueno", "potencialField": "potpozosStufingBueno" },
      { "name": "Pozos con Stuffing Malo", "activitiesField": "pozosStufingMalo", "potencialField": "potpozosStufingMalo" }
    ]
  },
  "estadosSelector": {
    "Title": "Estado Selector",
    "header": ['Tipo Actividad', 'Actividades', 'Potencial (BNPD)'],
    "data": [
      { "name": "Pozos con Selector Bueno", "activitiesField": "pozosSelectorBueno", "potencialField": "potpozosSelectorBueno" },
      { "name": "Pozos con Selector Malo", "activitiesField": "pozosSelectorMalo", "potencialField": "potpozosSelectorMalo" }
    ]
  },
  "tomaMuestra": {
    "Title": "Estado Toma Muestra",
    "header": ['Tipo Actividad', 'Actividades', 'Potencial (BNPD)'],
    "data": [
      { "name": "Pozos con Toma Muestra Bueno", "activitiesField": "pozosValvulaTomaMuestraBuenos", "potencialField": "potpozosValvulaTomaMuestraBuenos" },
      { "name": "Pozos con Toma Muestra Malo", "activitiesField": "pozosValvulaTomaMuestraMalos", "potencialField": "potpozosValvulaTomaMuestraMalos" }
    ]
  },
  "sonolog": {
    "Title": "Estado Sonolog",
    "header": ['Tipo Actividad', 'Actividades', 'Potencial (BNPD)'],
    "data": [
      { "name": "Pozos con Sonolog Bueno", "activitiesField": "pozosSonologBueno", "potencialField": "potpozosSonologBueno" },
      { "name": "Pozos con Sonolog Malo", "activitiesField": "pozosSonologMalo", "potencialField": "potpozosSonologMalo" }
    ]
  },
  "valvula2da4": {
    "Title": "Estado Valvula 2da 4",
    "header": ['Tipo Actividad', 'Actividades', 'Potencial (BNPD)'],
    "data": [
      { "name": "Pozos con valvula 2da 4 Bueno", "activitiesField": "pozosValvula2da4Buenos", "potencialField": "potpozosValvula2da4Buenos" },
      { "name": "Pozos con valvula 2da 4 Malo", "activitiesField": "pozosValvula2da4Malos", "potencialField": "potpozosValvula2da4Malos" }
    ]
  },
  "frenos": {
    "Title": "Estado de frenos",
    "header": ['Tipo Actividad', 'Actividades', 'Potencial (BNPD)'],
    "data": [
      { "name": "Pozos con frenos Bueno", "activitiesField": "pozosFrenosBuenos", "potencialField": "potpozosFrenosBuenos" },
      { "name": "Pozos con frenos Malo", "activitiesField": "pozosFrenosMalos", "potencialField": "potpozosFrenosMalos" }
    ]
  },
  "echometerBM": {
    "Title": "Activiaddes Echometer BM",
    "header": ['Tipo Actividad', 'Actividades', 'Potencial (BNPD)'],
    "data": [
      { "name": "Estudio Completo", "activitiesField": "pozosEstudiosCompletosEchometer", "potencialField": "potpozosEstudiosCompletosEchometer" },
      { "name": "Carta Dinagrafica", "activitiesField": "pozosCartasEchometer", "potencialField": "potpozosCartasEchometer" },
      { "name": "Nivel Dinámico", "activitiesField": "pozosNivelDinamicoEchometer", "potencialField": "potpozosNivelDinamicoEchometer" },
      { "name": "Nivel Dinámico", "activitiesField": "pozosNivelEstaticoEchometer", "potencialField": "potpozosNivelEstaticoEchometer" },
      { "name": "Nivel Estático", "activitiesField": "", "potencialField": "" },
      { "name": "Revisión", "activitiesField": "pozosRevisionEchometer", "potencialField": "potpozosRevisionEchometer" },
    ]
  },
  "leutertBM": {
    "Title": "Activiaddes Leutert BM",
    "header": ['Tipo Actividad', 'Actividades', 'Potencial (BNPD)'],
    "data": [
      { "name": "Carta Leuter", "activitiesField": "pozosCartasLeuter", "potencialField": "potpozosCartasLeuter" },
      { "name": "Revisión", "activitiesField": "pozosRevisionLeuter", "potencialField": "potpozosRevisionLeuter" }
    ]
  },
  "echometerBCP": {
    "Title": "Activiaddes Echometer BCP",
    "header": ['Tipo Actividad', 'Actividades', 'Potencial (BNPD)'],
    "data": [
      { "name": "Nivel Dinámico", "activitiesField": "pozosNivelDinamicoBCP", "potencialField": "potpozosNivelDinamicoBCP" },
      { "name": "Nivel Estático", "activitiesField": "pozosNivelEstaticoBCP", "potencialField": "potpozosNivelEstaticoBCP" },
      { "name": "Revisión", "activitiesField": "pozosRevisionBCP", "potencialField": "potpozosRevisionBCP" },
    ]
  }
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const DailyCloseTabletsModule = ({ data, field }: { data: any, field: string }) => {

  const dataToDowload: dataToDowload[] = []

  const [activeSummaryView, setactiveSummaryView] = useState(internalTabs[0].value)

  const handleDownloadCSV = () => {
    try {
      if (dataToDowload.length > 0) {
        const csv = convertArrayOfObjectsToCSV(dataToDowload);
        const utf8Bom = "\uFEFF"; // UTF-8 BOM
        const csvWithBom = utf8Bom + csv;
        const blob = new Blob([csvWithBom], { type: "text/csv;charset=utf-8;" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.setAttribute("hidden", "");
        a.setAttribute("href", url);
        a.setAttribute("download", `${field}_resumen.csv`);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
    } catch (error) {
      console.log({ error });
    }
  };

  const handleCopyToClipboard = () => {
    try {
      if (dataToDowload.length > 0) {
        const csv = convertArrayOfObjectsToCSV(dataToDowload);
        const utf8Bom = "\uFEFF"; // UTF-8 BOM
        const csvWithBom = utf8Bom + csv;
        navigator.clipboard.writeText(csvWithBom).then(() => {
          alert('Mensaje copiado al portapapeles');
        }).catch(err => {
          console.error('Could not copy text: ', err);
        });
      }
    } catch (error) {
      console.log({ error });
    }
  };


  return (
    <div className='section'>
      <Box sx={{ display: "flex", justifyContent: "space-between", }}>
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", ml: 2, gap: 1 }}>
          {
            internalTabs.map((item, index) => {
              return (
                <IconButton
                  onClick={() => setactiveSummaryView(item.value)}
                  key={index}
                  className="active_button"
                  sx={{
                    backgroundColor: activeSummaryView === item.value ? "#1976d2" : "#f0f0f0",
                    color: activeSummaryView === item.value ? "#fff" : "#000",
                    "&:hover": {
                      backgroundColor: activeSummaryView === item.value ? "#42a5f5" : "#f0f0f0",
                    },
                  }}
                >
                  {item.icon}
                </IconButton>
              )
            })
          }
        </Box>
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <IconButton
            onClick={handleDownloadCSV}
          >
            <DownloadIcon />
          </IconButton>
          <IconButton
            onClick={handleCopyToClipboard}
          >
            <ContentCopyIcon />
          </IconButton>
        </Box>
      </Box>

      {activeSummaryView === 'summary' && (
        <>
          {Object.keys(tablets).map((key, index) => {
            dataToDowload.push({
              section: "====================",
              name: "====================",
              activitiesField: "====================",
              potencialField: "===================="
            })
            return (
              <div key={index} className='sub_section'>
                <div className='title_table_section'>{tablets[key].Title}</div>
                {/* Headers */}
                <div className='header_section'>
                  {tablets[key].header.map((header, i) => {
                    return (
                      <div key={i}>{header}</div>
                    )
                  })}
                </div>
                {/* Body */}
                <div className=''>
                  {tablets[key].data.map((item, i) => {
                    dataToDowload.push({
                      section: tablets[key].Title,
                      name: item.name,
                      activitiesField: data[item.activitiesField] || 0,
                      potencialField: data[item.potencialField] || 0
                    })
                    return (
                      <div key={i} className='row_section'>
                        <div>{item.name}</div>
                        <div>{data[item.activitiesField] || 0}</div>
                        <div>{data[item.potencialField] || 0}</div>
                      </div>
                    )
                  })}

                </div>
              </div>
            )
          })}
        </>
      )}

      {activeSummaryView === 'charts' && <ChartForSummary data={data} field={field} />}

    </div>
  )
}

export const DailySummaryModule = () => {

  const mainState = useSelector(selectGtoState);

  const [loading, setloading] = useState(false)

  const navigate = useNavigate();

  const [data, setData] = useState(undefined)

  const [value, setValue] = useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  useEffect(() => {
    const filters = mainState.reportFilters;
    const report = mainState?.reportFilters?.activeReport;

    if (filters && report) {
      setloading(true);
      getDailySummaryReportAlone(
        report?.id,
        report?.code,
        filters?.startDate || "",
        filters?.endDate || "",
        filters?.projectId || ""
      ).then((data) => {
        setloading(false);
        setData(data)
      })
    }

  }, [mainState])

  const handleGoToDashboard = () => {
    navigate('/gto/dashboard');
  };

  return (
    <WrapMain>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
        }}
      >
        {/* Title */}
        <Box className="history_task_container_header">
          <ButtonCircle
            icon="/assets/icons/back.svg"
            iconHeight={50}
            iconWidth={50}
            onClick={() => handleGoToDashboard()}
          />
          <Box className="history_task_container_title">
            Resumen Diario
          </Box>
        </Box>
        <Grid size={12}>
          <Box>
            <Box
              sx={{ borderBottom: 1, borderColor: "divider" }}
            >
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
                variant='fullWidth'
              >
                <Tab label="Lagunillas" {...a11yProps(0)} />
                <Tab label="Bachaquero" {...a11yProps(1)} />
              </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0}>
              {(data && data['Lagunillas']) ? <DailyCloseTabletsModule data={data['Lagunillas']} field='Lagunillas' /> : <div>Sin Data...</div>}
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              {(data && data['Bachaquero']) ? <DailyCloseTabletsModule data={data['Bachaquero']} field='Bachaquero' /> : <div>Sin Data...</div>}
            </CustomTabPanel>
            {loading && (
              <>
                <Box className="modal_analyst_loading_background" />
                <Box className="modal__analyst_task_loading">
                  <LinearProgress />
                  Loading....
                </Box>
              </>
            )}
          </Box>
        </Grid>
      </Box>
    </WrapMain>
  )
}